export default __webpack_public_path__ + "static/Garmin-Pay-watch-200-teal-796d8ff037e60dbc33ee3eab2f679fd6.png";